<!--<div  fxLayout="row" fxLayoutAlign="space-around center"  style="color: #5F5F5F" class="flex">
  <div align="center" fxLayout="row" fxLayoutAlign="center center"  class="login-form">

    <form role="form" [formGroup]="formRegister" (ngSubmit)="onSubmit()">

      <mat-card class="mat-elevation-z8" flex="80">

        <mat-card-title>Cadastro</mat-card-title>

        <mat-card-content fxLayout="column" fxLayoutAlign="space-around stretch">

            <mat-form-field fxFlex="45" appearance="outline">
              <input matInput type="text" formControlName="name"
                     autocomplete="name" placeholder="Nome completo">
              <mat-error *ngIf="formRegister.get('name').hasError('required') ">Informe o nome</mat-error>
            </mat-form-field>

          <div fxLayout="row" fxLayoutAlign="space-between stretch">
            <mat-form-field fxFlex="100" appearance="outline">
              <input matInput type="email" formControlName="email"
                     class="form-control" value="" autocomplete="email" placeholder="E-mail" >
              <mat-error *ngIf="formRegister.get('email').hasError('email') ">Email inválido</mat-error>
              <mat-error *ngIf="formRegister.get('email').hasError('required') ">Informe o email</mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutAlign="space-between stretch">
            <mat-form-field fxFlex="60" appearance="outline">
              <input matInput type="text" formControlName="phone"
                     autocomplete="phone" placeholder="Telefone"   maxlength="11">
              <mat-error *ngIf="formRegister.get('phone').hasError('pattern') ">formato inválido</mat-error>
              <mat-error *ngIf="formRegister.get('phone').hasError('required') ">Informe o telefone</mat-error>
              <mat-error *ngIf="formRegister.get('phone').hasError('minlength') ">DD + telefone</mat-error>
            </mat-form-field>

            <mat-form-field  fxFlex="35" appearance="outline">
              <mat-select matNativeControl placeholder="Eu sou..." formControlName="profiles">
                <mat-option *ngFor="let profile of profiles" [value]="profile">
                  {{profile}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="formRegister.get('email').hasError('required') ">Esolha seu perfil</mat-error>
            </mat-form-field>
          </div>



          <div fxLayout="row" fxLayoutAlign="space-between stretch">
            <mat-form-field appearance="outline">
              <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" placeholder="Senha" autocomplete="password">
              <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-error *ngIf="formRegister.get('password').hasError('minlength') ">Senha deve conter ao menos 6 caracteres</mat-error>
              <mat-error *ngIf="formRegister.get('password').hasError('required') ">Informe a senha</mat-error>
            </mat-form-field>
            <div>
              <button mat-raised-button color="primary" type="submit" [disabled]="!formRegister.valid">
                <mat-icon>done</mat-icon>&nbsp;Cadastrar
              </button>
            </div>
          </div>






        </mat-card-content>
      </mat-card>
    </form>


  </div>
</div>-->
<div class="login-photo-container">
  <div class="login-overlay-color">
    <div class="login-form-container">
      <form  [formGroup]="formRegister" (ngSubmit)="onSubmit()" fxLayout="column" fxLayoutAlign="space-around stretch"  *ngIf="!loading">
        <img class="login-logo" src="../../../assets/logos/school-logo.png"/>
          <mat-form-field fxFlex="45" appearance="outline">
            <mat-label>Nome completo</mat-label>
            <input matInput type="text" formControlName="name"
                   autocomplete="name" placeholder="Nome completo">
            <mat-error *ngIf="formRegister.get('name')?.hasError('required') ">Informe o nome</mat-error>
          </mat-form-field>

          <div fxLayout="row" fxLayoutAlign="space-between stretch">
            <mat-form-field fxFlex="100" appearance="outline">
              <mat-label>E-mail</mat-label>
              <input matInput type="email" formControlName="email"
                     class="form-control" value="" autocomplete="email" placeholder="E-mail" >
              <mat-error *ngIf="formRegister.get('email')?.hasError('email') ">Email inválido</mat-error>
              <mat-error *ngIf="formRegister.get('email')?.hasError('required') ">Informe o email</mat-error>
            </mat-form-field>
          </div>

        <div fxLayout="row" fxLayoutAlign="space-between stretch">
          <mat-form-field fxFlex="60" appearance="outline">
            <mat-label>Telefone</mat-label>
            <input matInput type="text" formControlName="phone"
                   autocomplete="phone" placeholder="Telefone"   maxlength="11">
            <mat-error *ngIf="formRegister.get('phone')?.hasError('pattern') ">formato inválido</mat-error>
            <mat-error *ngIf="formRegister.get('phone')?.hasError('required') ">Informe o telefone</mat-error>
            <mat-error *ngIf="formRegister.get('phone')?.hasError('minlength') ">DD + telefone</mat-error>
          </mat-form-field>

          <mat-form-field  fxFlex="35" appearance="outline">
            <mat-label>Perfil</mat-label>
            <mat-select matNativeControl placeholder="Eu sou..." formControlName="profiles">
              <mat-option *ngFor="let profile of profiles" [value]="profile">
                {{profile}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formRegister.get('email')?.hasError('required') ">Esolha seu perfil</mat-error>
          </mat-form-field>
        </div>

          <mat-form-field appearance="outline">
            <mat-label>Senha</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" placeholder="Senha" autocomplete="password">
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" type="button">
              <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error *ngIf="formRegister.get('password')?.hasError('minlength') ">Senha deve conter ao menos 6 caracteres</mat-error>
            <mat-error *ngIf="formRegister.get('password')?.hasError('required') ">Informe a senha</mat-error>
          </mat-form-field>
        <!-- botao para enviar formulário -->
        <button mat-raised-button class="btn-register">Cadastrar</button>
      </form>
      <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
    </div>

  </div>
</div>
